export default __webpack_public_path__ + "static/media/language.decf6b99.svg";